import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const ContentBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(3),
}));
